import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { ArrowIcon as a } from "../../../assets/svgs/ArrowIcon.js";
const s = ({ title: c, cancelButtonAction: o }) => /* @__PURE__ */ t("div", { className: "breadcrumb-container", children: [
  /* @__PURE__ */ t("div", { className: "breadcrumb-content-container", children: [
    /* @__PURE__ */ r(
      "button",
      {
        onClick: o,
        "data-testid": "back-to-coupons-button",
        children: "Meus Cupons"
      }
    ),
    " ",
    /* @__PURE__ */ r(a, {}),
    " ",
    /* @__PURE__ */ r("span", { children: c })
  ] }),
  /* @__PURE__ */ t(
    "button",
    {
      className: "breadcrumb-back-button",
      onClick: o,
      "data-testid": "back-button",
      children: [
        /* @__PURE__ */ r(a, { color: "var(--color-support-links)", rotate: "Left" }),
        " Voltar"
      ]
    }
  )
] });
export {
  s as Breadcrumb
};
